import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import { PRODUCTS } from '../constants/products';
import ProductIcon from './ProductIcon';

const ProductsShowcase = () => {
  return (
    <section id="products" className="relative py-20 md:py-28 bg-surface border-t border-slate-200/80">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-14">
          <div className="max-w-2xl">
            <p className="text-sm font-semibold uppercase tracking-wider text-brand-violet mb-3">Our apps</p>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-slate-900 tracking-tight mb-4">
              Apps we ship on the App Store
            </h2>
            <p className="text-slate-600 text-lg leading-relaxed">
              From allergen scanning to on-device photo AI, trivia, and reflective reading—explore what we have published
              for iPhone.
            </p>
          </div>
          <div className="flex flex-col gap-2 self-start md:self-auto shrink-0">
            <Link
              to="/products"
              className="inline-flex items-center gap-2 text-sm font-semibold text-brand-violet hover:text-slate-900 transition-colors"
            >
              View all apps
              <FiArrowRight aria-hidden />
            </Link>
            <Link to="/neonverse" className="text-sm text-slate-600 underline">
              Neon Verse (test)
            </Link>
          </div>
        </div>

        <ul className="grid gap-4 sm:grid-cols-2">
          {PRODUCTS.map((p) => (
            <li key={p.slug}>
              <Link
                to={`/products/${p.slug}`}
                className="flex flex-col h-full rounded-2xl border border-slate-200 bg-white p-5 shadow-card hover:border-brand-cyan/35 hover:shadow-brand transition-all group"
              >
                <div className="flex gap-3 mb-2">
                  <ProductIcon name={p.name} src={p.iconSrc} size="sm" className="shrink-0" />
                  <div className="min-w-0">
                    <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-0.5">{p.category}</p>
                    <h3 className="font-display font-bold text-slate-900 group-hover:text-brand-violet transition-colors leading-snug">
                      {p.name}
                    </h3>
                  </div>
                </div>
                <p className="text-sm text-slate-600 mt-1 line-clamp-2 leading-relaxed">{p.summary}</p>
                <span className="mt-4 text-sm font-semibold text-brand-violet inline-flex items-center gap-1">
                  Details
                  <FiArrowRight className="text-xs transition-transform group-hover:translate-x-0.5" aria-hidden />
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default ProductsShowcase;
